import SectionCard from "./SectionCard";

export default function SummaryTab({ candidate }) {
  return (
    <SectionCard title="Bio / Summary">
      <p style={{ fontSize: 14, color: "var(--fc-text-muted)", lineHeight: 1.8, margin: 0 }}>
        {candidate.bio || "No summary added yet."}
      </p>
    </SectionCard>
  );
}
